import TermsAndConditions from './terms-and-conditions';

export default TermsAndConditions;